module.exports = "/components/components/photoswipeComponent-e696aa.html";